import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/services/api';
import { toast } from 'sonner';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // Set page title
  useEffect(() => {
    document.title = 'Iniciar Sesión - MAUMA Admin';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.login(email, password);
      toast.success('Bienvenido a MAUMA');
      onLogin(response.data.user, response.data.token);
    } catch (error) {
      toast.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAF8F5] via-[#F5F2ED] to-[#FAF8F5] flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 bg-white/80 backdrop-blur-sm border-[#C9A961]/20 shadow-xl">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_793a21d1-f278-4746-b089-be151b084274/artifacts/9la08ask_LogoMauma_Cuadrado.png"
              alt="MAUMA Logo"
              className="w-48 h-48 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-[#2C2C2C]">Sistema de Gestión</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-[#2C2C2C] font-medium">Email</Label>
            <Input
              id="email"
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 border-[#C9A961]/30 focus:border-[#C9A961] focus:ring-[#C9A961]"
              required
            />
          </div>

          <div className="pb-6">
            <Label htmlFor="password" className="text-[#2C2C2C] font-medium">Contraseña</Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 border-[#C9A961]/30 focus:border-[#C9A961] focus:ring-[#C9A961]"
              required
            />
          </div>

          <Button
            type="submit"
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[#C9A961] hover:bg-[#B89551] text-white font-medium py-6 text-base"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-[#6B6B6B]">
          <p>Beauty House · Head Spa</p>
        </div>
      </Card>
    </div>
  );
};

export default Login;